import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-download-wo-popup',
  templateUrl: './download-wo-popup.component.html',
  styleUrls: ['./download-wo-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  // eslint-disable-next-line @angular-eslint/prefer-standalone -- pre-existing debt: declared in SharedModule
  standalone: false,
})
export class DownloadWoPopupComponent {
  private fb = inject(FormBuilder);
  private dialogRef = inject<MatDialogRef<DownloadWoPopupComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  downloadWoForm: FormGroup;

  constructor() {
    this.downloadWoForm = this.fb.group({
      includeLinkedWo: [true],
      // The "Include media" checkbox is commented out in the template; the control stays so
      // the payload shape is unchanged, defaulted to false so media is not downloaded.
      includeMedia: [false]
    });
  }

  onDownloadPhotos(): void {
    const values = this.downloadWoForm.value;
    this.dialogRef.close(values);
  }
}
